import React, { useEffect, useState } from 'react';
import { Routes, Route, useSearchParams, useNavigate } from 'react-router-dom';
import { Home } from './pages/home';
import { RequestCertificatePage } from './pages/requestCertificate';
import HelpPage from './pages/help';
import { RequestDetails } from './pages/requestDetails';
import { useSelector } from 'react-redux';
import { SomeThingWentWrong } from './components/error';
import ErrorPage from './pages/error';
import Broken from './pages/broken';
import { AdminHome } from './pages/adminHome';
import { get } from './config/api';
import { UserInfo } from './pages/home';
import { API_ENDPOINTS } from './config/apiEndpoints';
import { Loader } from './components/loader';

interface User extends UserInfo {
  role?: string;
}

function App() {
  const errorConfig = useSelector((state: any) => state.errorConfig);
   const navigate = useNavigate();
  const [userData, setUserData] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();

  const FetchAndSetUserINFO = async (cwid: string) => {
    let user: User | null = null;

    try {
      // First, try to get user details
      const response = await get(API_ENDPOINTS.GET_USER_DETAILS(cwid, 'IN'));
      if (response) {
        // Transform new access-based structure to flat structure
        if (response.access && Array.isArray(response.access) && response.access.length > 0) {
          const primaryAccess = response.access.find((a: any) => a.role === 'ISSUER') || response.access[0];
          user = {
            ...response,
            role: primaryAccess.role,
            mappedLocations: primaryAccess.mappedLocations || [],
            unit: primaryAccess.mappedLocations?.[0]?.unit_code || '',
          };
          delete (user as any).access;
        } else {
          user = response;
        }
      }
    } catch (userError) {
      console.log(`Failed to fetch user details for cwid ${cwid}, trying partner API.`, userError);
    }

    // If the user call failed or returned no user, try the partner call
    if (!user) {
      try {
        const partner = await get(API_ENDPOINTS.SEARCH_PARTNER_BY_ID(cwid));
        if (partner) {
          user = { ...partner, userId: partner.partner_id, role: 'Retailer' };
        }
      } catch (partnerError) {
        console.error(`Failed to fetch partner details for cwid ${cwid}.`, partnerError);
      }
    }

    if (user) {  
      console.log('Fetched user data:', user);
      localStorage.setItem('userData', JSON.stringify(user));
      setUserData(user);
    } else {
      // If both calls fail, navigate to the error page
      navigate('/error');
    }
    setIsLoading(false);
  }

  useEffect(() => {
    let userid = searchParams.get('userId');
    if (userid) {
      localStorage.setItem('USER_ID', userid);
      FetchAndSetUserINFO(userid);
    } else {
      userid = localStorage.getItem('USER_ID');
      if (userid) {
        FetchAndSetUserINFO(userid);
      } else {
        navigate('/error');
      }
    }
  }, [searchParams, navigate]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {errorConfig.isError && <SomeThingWentWrong errorMsg={errorConfig.errorMsg} />}
      <Routes>
        <Route path="/" element={userData?.role === 'ISSUER' ? <AdminHome /> : <Home />} />
        <Route path="/request-certificate" element={<RequestCertificatePage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/summary" element={<RequestDetails />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/broken" element={<Broken />} />
      </Routes>
    </>
  );
}

export default App;